import { Component, OnInit, Input, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


import { Observable, Subscription } from 'rxjs';
import { Client } from 'src/app/entity/exhibitor';
import { Facture, Socifact, Devise } from 'src/app/entity/Facture';
import { Contact } from 'src/app/entity/Contact';
import { Prospect } from 'src/app/entity/prospect';
import { Staff } from 'src/app/entity/Staff';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { FactureService } from 'src/app/service/facture.service';
import { PanierFormComponent } from '../panier-form/panier-form.component';




@Component({
  selector: 'app-facturation-form',
  templateUrl: './facturation-form.component.html',
  styleUrls: ['./facturation-form.component.scss']
})
export class FacturationFormComponent implements OnInit, OnDestroy {


  @Input() client: Client;
  @Input() form: FormGroup;
  user: Staff;
  selectedInvoice: Facture;
  contacts: Observable<Contact[]>;
  customers: Observable<Prospect[]>;
  socifacts: Observable<Socifact[]>;
  subscriptionInvoice: Subscription;
  deviseChanged: boolean;
  socifactChanged: boolean;
  contactChanged: boolean;
  devises = [];
  selectedDevise: string;
  busyChanged: boolean;



  @Output() onChangedFacture = new EventEmitter<any>();

  constructor(private fb: FormBuilder, private clientService: ExhibitorService, private factureService: FactureService) { }

  ngOnInit() {



    this.subscriptionInvoice = this.factureService.getSelectedInvoice().subscribe(result => {
      this.selectedInvoice = result;
      if (this.selectedInvoice) {

        this.contacts = this.clientService.findContacts(this.selectedInvoice.prospectprospectId.prospectId);

        this.initFormGroupe();
      }
    });

    this.findContract();
    this.onChanges();
    this.initSociDevise();
 
  this.onFormChange();
 
  }
  emitChangeFacture() {
    this.onChangedFacture.next()
  }

  findContacts() {
    console.log("facturation contact changed");
    if (this.selectedInvoice && this.selectedInvoice.prospectprospectId) {

      this.contacts = this.clientService.findContacts(this.selectedInvoice.prospectprospectId.prospectId);

      this.contacts.subscribe(result => {
        result.forEach(element => {
          console.log("element", element.mobile);

          if (element.contactId == this.selectedInvoice.contactcontactId.contactId) {

            this.form.controls['contactSelect'].setValue(element);
            this.selectedInvoice.contactcontactId = element;

            this.form.controls['tel'].setValue(element.tel);
            this.form.controls['mail'].setValue(element.mail);
          }


        });

      })
    }

  }

  voirContactstest() {
    this.contacts = this.clientService.findContacts(this.selectedInvoice.prospectprospectId.prospectId);

    this.contacts.subscribe(result => {
      result.forEach(element => {
        console.log("element", element.mobile);



      });

    })
  }


  findContract() {
    this.factureService.findContract(this.client.idClient).subscribe(result => {
      this.selectedInvoice = result;
      if (this.selectedInvoice) {


        this.factureService.selectInvoice(this.selectedInvoice)
        this.contacts = this.clientService.findContacts(this.selectedInvoice.prospectprospectId.prospectId);

        this.initFormGroupe();
      }

    })
  }
  changeDevise() {
    //console.log("devisechnaged");

    this.deviseChanged = true;


  }

  alertChangeDevise() {
    if (!this.busyChanged) {
      this.busyChanged = true;
      setTimeout(() => {
        this.busyChanged = false;
        window.alert("Vous avez changer le devise!! noublier pas de changer les prix de la facture proforma");
      }, 2000);

    }
  }
  changeContact() {
    this.contactChanged = true;

  }
  changeSociFact() {
    this.socifactChanged = true;
    console.log("this.socifactChanged   0");

  }



  initSociDevise() {
    this.socifacts = this.factureService.getAllSociFactOrder();


    this.devises = [
      { label: 'Dinars algérien', value: 'dzd' },
      { label: 'Euro', value: 'eur' },
      { label: 'Dollar des états unis', value: 'usd' },
    ];
  }

  initFormGroupe() {
console.log("this.selectedInvoice.datefacture",this.selectedInvoice.datefacture);


    this.form.patchValue({
      'billingCompany': this.selectedInvoice.prospectprospectId,
      'contactSelect': this.selectedInvoice.contactcontactId,
      'tel': this.selectedInvoice.contactcontactId.tel,
      'mail': this.selectedInvoice.contactcontactId.mail,
      'company': this.selectedInvoice.sociFactSociFactId,
      'currency': this.selectedInvoice.devise,
      'tva': this.selectedInvoice.tva,
      'dateInvoice': new Date(this.selectedInvoice.datefacture).getFullYear()<2022? new Date():new Date(this.selectedInvoice.datefacture),

      'montanttva': this.selectedInvoice.montanttva,
      'timbre': this.selectedInvoice.timbre,
      'finance': this.selectedInvoice.finance,
      'annuler': this.selectedInvoice.annuler,
      'observation': this.selectedInvoice.observation,

    });
    //console.log("montanttva " + this.selectedInvoice.montanttva);

    this.selectedDevise = this.selectedInvoice.devise;
  }

  onFormChange() {
console.log("11");



    this.form.valueChanges.subscribe(result => {
      console.log("onFormChange", this.form.status);

      if (this.selectedInvoice.sociFactSociFactId != this.form.value.company) {
        this.selectedInvoice.sociFactSociFactId = this.form.value.company;
        console.log("this.socifactChanged  this.form.valueChanges");
        this.socifactChanged = false;
        if (this.form.controls['currency'] != this.form.value.company.deviseId.symbol) {
          this.alertChangeDevise()
        }

        this.form.controls['currency'].setValue(this.form.value.company.deviseId.symbol);
        console.log("this.form.value.company.deviseId.symbol", this.form.value.company.deviseId.symbol);

        //console.log("this.selectedInvoice.sociFactSociFactId.tva",this.selectedInvoice.sociFactSociFactId.tva);
        this.form.controls['tva'].setValue(this.selectedInvoice.sociFactSociFactId.tva > 0);
        this.form.controls['montanttva'].setValue(this.selectedInvoice.sociFactSociFactId.tva);

      }
      else if (this.deviseChanged) {
        this.deviseChanged = false;
        // this.form.controls['tva'].setValue(this.form.controls['currency'].value === "dzd");

      }
      else if (this.contactChanged) {
        console.log("this.form.value.contactSelect", this.form.value.contactSelect.mobile);

        this.selectedInvoice.contactcontactId = this.form.value.contactSelect;


        this.contactChanged = false
        //console.log(this.selectedInvoice.contactcontactId);

        this.form.controls['tel'].setValue(this.selectedInvoice.contactcontactId.tel);
        this.form.controls['mail'].setValue(this.selectedInvoice.contactcontactId.mail);
      }


      this.getFacturationForm();

      console.log(this.selectedInvoice,"this.selectedInvoice");
      
 
      this.factureService.save(this.selectedInvoice).subscribe(result => {

        this.emitChangeFacture()


      });

 
      this.selectedDevise = this.selectedInvoice.devise;


      this.voirContactstest()
    })

  }



  onChanges(): void {


    this.form.controls.billingCompany.valueChanges.subscribe(val => {

      if (val) {
        const vals = val + "";
        if (vals.length > 0)
          this.customers = this.clientService.findConfByRaison(val);


      }
    });
  }

  changeCBC(prospectId: Prospect) {

    console.log("changeCBC");

    this.selectedInvoice.prospectprospectId = prospectId;
    this.contacts = this.clientService.findContacts(this.selectedInvoice.prospectprospectId.prospectId);
    this.clientService.findContacts(this.selectedInvoice.prospectprospectId.prospectId).subscribe(result => {
      if (result) {
        this.selectedInvoice.contactcontactId = result[0];
        this.initFormGroupe();
      }
    });
  }


  displayFn(prospect?: Prospect): string | undefined {
    return prospect ? prospect.raisonSocial : "";
  }


  compareFn(c1: Contact, c2: Contact): boolean {
    return c1 && c2 ? c1.contactId === c2.contactId : c1 === c2;
  }
  compareSociFact(c1: Socifact, c2: Socifact): boolean {
    return c1 && c2 ? c1.sociFactId === c2.sociFactId : c1 === c2;
  }
  compareDevise(c1: Devise, c2: Devise): boolean {
    return c1 && c2 ? c1.deviseId === c2.deviseId : c1 === c2;
  }
  compareCUMSBillFn(c1: Prospect, c2: Prospect): boolean {
    return c1 && c2 ? c1.prospectId === c2.prospectId : c1 === c2;
  }


  getFacturationForm() {
    if (this.form && this.selectedInvoice) {
      this.selectedInvoice.prospectprospectId = this.form.value.billingCompany;
      this.selectedInvoice.contactcontactId = this.form.value.contactSelect;


      this.selectedInvoice.devise = this.form.value.currency;
      this.selectedInvoice.sociFactSociFactId = this.form.value.company;


      this.selectedInvoice.tva = this.form.value.tva;
      this.selectedInvoice.montanttva = this.form.value.montanttva;
      this.selectedInvoice.timbre = this.form.value.timbre;
      this.selectedInvoice.finance = this.form.value.finance;
      this.selectedInvoice.annuler = this.form.value.annuler;
      this.selectedInvoice.observation = this.form.value.observation;

      this.selectedInvoice.datefacture=this.form.value.dateInvoice;
      this.selectedInvoice.datefacture.setHours(11);

     // this.selectedInvoice.datefacture+=60*60*100;
      console.log("fsdf",this.form.value.dateInvoice);
      





    }


  }
  ngOnDestroy(): void {
    this.subscriptionInvoice.unsubscribe();
  }


  deviseName() {

  }
}